import { Box, TabList, Tab, TabPanel, TabPanels, Tabs, useMediaQuery, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import { Paper, SelectField } from '@app/components/common';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';
import Error404 from '@app/pages/errors/404';

import { tabs } from './navigation';

export const EquipmentsImportPage = () => {
  const [isSmall] = useMediaQuery('(max-width: 768px)', {
    fallback: true
  });

  const canUpload = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });

  if (!canUpload) {return <Error404 />;}

  if(isSmall) {return <EquipmentsImportMobilePage />;}
  return <Box>
    <Paper>
      <Tabs isLazy>
        <TabList>
          {tabs.map((tab, index) => <Tab key={index} >{tab.name}</Tab>)}
        </TabList>
        <TabPanels >
          {tabs.map(({ component: Component }, index) => <TabPanel key={index}><Component /></TabPanel>)}
        </TabPanels>
      </Tabs>
    </Paper>
  </Box>;
};


const EquipmentsImportMobilePage = () => {
  const [currentTab, setCurrentTab] = useState(tabs[0]);

  const Tab = currentTab.component;

  return <Box>
    <Paper>
      <Flex direction='column' gap={5}>
        <Box mx={4} mt={4}>
          <SelectField 
            id='tab'
            label='Справочник'
            value={currentTab}
            options={tabs}
            onChange={setCurrentTab}
            clearable={false}
          />
        </Box>
        <Box>
          <Tab />
        </Box>
      </Flex>
    </Paper>
  </Box>;
};